import {
  ReactNode,
  createContext,
  useCallback,
  useLayoutEffect,
  useMemo,
  useState,
} from "react";
import { User, onAuthStateChanged } from "firebase/auth";
import { Loader } from "../components/Loader";
import { auth } from "../libs/firebase";

interface IAppProviderProps {
  children: ReactNode;
}

interface IDefaultValues {
  fbUser: null | User;
}

const defaultValues: IDefaultValues = {
  fbUser: null,
};

const AppContext = createContext(defaultValues);

export const AppConsumer = AppContext.Consumer;

export function AppProvider({ children }: IAppProviderProps) {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [fbUser, setFbUser] = useState<null | User>(defaultValues.fbUser);

  const checkSession = useCallback(async () => {
    try {
      onAuthStateChanged(auth, async (firebaseUser) => {
        if (firebaseUser) {
          setFbUser(firebaseUser);
        } else {
          setFbUser(null);
        }

        setIsLoading(false);
      });
    } catch {
      setIsLoading(false);
    }
  }, []);

  useLayoutEffect(() => {
    checkSession();
  }, [checkSession]);

  const memoizedValues = useMemo(
    () => ({
      fbUser,
    }),
    [fbUser],
  );

  return (
    <AppContext.Provider value={memoizedValues}>
      {isLoading ? <Loader /> : children}
    </AppContext.Provider>
  );
}

export default AppContext;
